// Centralized gallery data — used by PortfolioGallery (and its lightbox).
// Images are the studio's own photography (public/images/gallery/).
const gallery = [
  {
    src: "/images/gallery/gallery-1-tall.webp",
    full: "/images/gallery/gallery-1-tall.webp",
    caption: "Welcome signage, garden ceremony",
    size: "tall",
  },
  {
    src: "/images/gallery/gallery-2-wide.webp",
    full: "/images/gallery/gallery-2-wide.webp",
    caption: "Ceremony aisle, modern white & gold",
    size: "wide",
  },
  {
    src: "/images/gallery/gallery-3-square.webp",
    full: "/images/gallery/gallery-3-square.webp",
    caption: "Floral hoop wedding cake",
    size: "square",
  },
  {
    src: "/images/gallery/gallery-4-tall.webp",
    full: "/images/gallery/gallery-4-tall.webp",
    caption: "Floral stand detail",
    size: "tall",
  },
  {
    src: "/images/gallery/gallery-5-square.webp",
    full: "/images/gallery/gallery-5-square.webp",
    caption: "Illuminated floral backdrop",
    size: "square",
  },
  {
    src: "/images/gallery/gallery-6-wide.webp",
    full: "/images/gallery/gallery-6-wide.webp",
    caption: "Hanging floral ceremony arch",
    size: "wide",
  },
  {
    src: "/images/gallery/gallery-7-square.webp",
    full: "/images/gallery/gallery-7-square.webp",
    caption: "Carved gold stage detail",
    size: "square",
  },
  {
    src: "/images/gallery/gallery-8-tall.webp",
    full: "/images/gallery/gallery-8-tall.webp",
    caption: "Traditional brass lamp ritual",
    size: "tall",
  },
];

export default gallery;
